module.exports = __webpack_public_path__ + "static/media/bison-burger-mobile-en.bab9d11a.jpg";